import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;
export const LimitesContainer = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const LimiteItem = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
`;

export const HelpContainer = styled.View``;

export const HelpTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(2)}px;
`;
